<div class="demo-scroll-container">
    <upp-scrollable [scrollbar]="'y'">
        <div class="demo-content">
            <h2>upp-header — Page Headers</h2>
            <p class="demo-description">Different <code>upp-header</code> configurations as they'd appear across pages of a real application.</p>

            <div class="demo-controls">
    <ion-button size="small" (click)="cycleColor()">Cycle color: {{ dynamicColor }}</ion-button>
</div>

<!-- Products page header -->
<div class="demo-section">
    <h3>Products page</h3>
    <upp-header color="primary" menu="show" height="50px">
        <upp-header-title>Products</upp-header-title>
        <upp-header-button>
            <ion-icon name="add-outline"></ion-icon>
        </upp-header-button>
        <upp-header-button>
            <ion-icon name="filter-outline"></ion-icon>
        </upp-header-button>
    </upp-header>
</div>

<!-- Order detail header -->
<div class="demo-section">
    <h3>Order detail</h3>
    <upp-header color="success" menu="hide" height="50px">
        <upp-header-title>Order #1234</upp-header-title>
        <upp-header-button>
            <ion-icon name="print-outline"></ion-icon>
        </upp-header-button>
    </upp-header>
</div>

<!-- Alert banner header -->
<div class="demo-section">
    <h3>Alert banner</h3>
    <upp-header color="danger" menu="hide" height="40px">
        <upp-header-content>
            <div class="alert-header-content">
                <ion-icon name="warning-outline"></ion-icon>
                <span>Connection lost — retrying in 5s</span>
            </div>
        </upp-header-content>
    </upp-header>
</div>

<!-- Minimal settings header -->
<div class="demo-section">
    <h3>Minimal header</h3>
    <upp-header color="medium" menu="hide" height="50px">
        <upp-header-title>Settings</upp-header-title>
    </upp-header>
</div>

<!-- Dynamic color header -->
<div class="demo-section">
    <h3>Dynamic color: {{ dynamicColor }}</h3>
    <upp-header [color]="dynamicColor" menu="show" height="50px">
        <upp-header-title>Dynamic Header</upp-header-title>
        <upp-header-button>
            <ion-icon name="ellipsis-vertical"></ion-icon>
        </upp-header-button>
    </upp-header>
</div>
        </div>
    </upp-scrollable>
</div>
